import { memo, useContext } from "react";
import { useSelector } from "react-redux";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import FormField from "layouts/Flow Designer/components/FormField";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import { FormFieldsContext } from "layouts/Flow Designer/context";
import OptionLabel from "./OptionLabel";
import StyledDivider from "./StyledDivider";

const styles = {
  gap: {
    gap: 10
  },
  listItemMargin_t16: {
    marginTop: "16px"
  },
  w100: {
    width: "100%"
  }
};

const KeyValueInputs = ({
  field,
  fieldName,
  buttonTitle,
  isPayloadContent = false,
  allowEditWorkflow
}) => {
  const formRef = useContext(FormFieldsContext);
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";

  return (
    <>
      <div style={{ marginBottom: ".5rem", marginTop: ".5rem" }}>
        <OptionLabel
          label={field.label}
          name={fieldName}
          isPayloadContent={isPayloadContent}
          allowEditWorkflow={allowEditWorkflow}
        />
      </div>
      {formRef?.values && (
        <List>
          <ListItem sx={styles.gap}>
            <SoftBox display="flex" flexDirection="column" width="100%" gap={2}>
              {formRef?.values[fieldName].map((h, idx) => {
                return (
                  <FormField
                    key={idx}
                    type={field.type}
                    label={isPayloadContent ? "" : "Header"}
                    name={field.name}
                    value={h.value}
                    index={idx}
                    isDisabled={field.type === "select" && !allowEditWorkflow}
                    disabled={isFlowActive || !allowEditWorkflow}
                  />
                );
              })}
            </SoftBox>
          </ListItem>
        </List>
      )}
      <SoftBox sx={{ display: "flex", justifyContent: "center" }}>
        <SoftButton
          variant="outlined"
          color="primary"
          sx={styles.listItemMargin_t16}
          onClick={() => {
            formRef?.setFieldValue(fieldName, [
              ...(formRef?.values?.[fieldName] ?? []),
              { key: "", value: "" }
            ]);
          }}
          disabled={isFlowActive || !allowEditWorkflow}
        >
          {buttonTitle}
        </SoftButton>
      </SoftBox>
      {!isPayloadContent && <StyledDivider />}
    </>
  );
};

export default memo(KeyValueInputs);
